import type { Route } from '../backend/route';

/**
 * How a traveller is named across every surface — hero copy, tab title and
 * share tags. Kept in one place because the three used to disagree: the hero
 * rendered `@anna_b` while the share preview said `anna_b`, so re-sharing a
 * page produced a preview whose name didn't match the page it opened.
 *
 * Returns `null` rather than a placeholder when the route carries no usable
 * name. Callers decide what that means: in-page copy can live with an em
 * dash, but "— is on the way" would be a nonsense share preview, so
 * `socialMeta` drops to generic copy instead.
 */
export function travellerName(route: Route | null): string | null {
  const creator = route?.creator;
  if (!creator) return null;

  const name = creator.name?.trim();
  if (name) return name;

  // Usernames are shown with the @ that marks them as handles rather than
  // display names — same convention as the mobile apps.
  const username = creator.username?.trim();
  return username ? `@${username}` : null;
}
